import { useEffect, useState } from 'react';
import { io } from 'socket.io-client';

// Strip '/api' suffix from the REST base URL — socket.io mounts at the server root.
const resolveSocketUrl = () => {
  const raw = process.env.REACT_APP_API_BASE_URL || '';
  return raw.replace(/\/api\/?$/, '') || undefined;
};

export default function usePresence() {
  const [online, setOnline] = useState(() => new Set());
  const [lastSeen, setLastSeen] = useState(() => new Map());

  useEffect(() => {
    const url = resolveSocketUrl();
    const socket = io(url, {
      auth: {
        apiKey: process.env.REACT_APP_API_KEY || '',
        role: 'admin',
      },
      transports: ['websocket', 'polling'],
    });

    socket.on('presence:snapshot', ({ online: uids = [] }) => {
      setOnline(new Set(uids));
    });

    socket.on('presence:online', ({ uid }) => {
      if (!uid) return;
      setOnline(prev => {
        const next = new Set(prev);
        next.add(uid);
        return next;
      });
    });

    socket.on('presence:offline', ({ uid, lastSeen: ls }) => {
      if (!uid) return;
      setOnline(prev => {
        if (!prev.has(uid)) return prev;
        const next = new Set(prev);
        next.delete(uid);
        return next;
      });
      if (ls) {
        setLastSeen(prev => {
          const next = new Map(prev);
          next.set(uid, ls);
          return next;
        });
      }
    });

    socket.on('connect_error', (err) => {
      console.warn('[Presence] connect_error', err?.message || err);
    });

    return () => {
      socket.removeAllListeners();
      socket.disconnect();
    };
  }, []);

  return { online, lastSeen };
}
